import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Group = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5ZM4 6.94999C2.85888 6.71836 2 5.70948 2 4.5C2 3.11929 3.11929 2 4.5 2C5.70948 2 6.71836 2.85888 6.94999 4H9.05001C9.28164 2.85888 10.2905 2 11.5 2C12.8807 2 14 3.11929 14 4.5C14 5.70948 13.1411 6.71836 12 6.94999V9.05001C13.1411 9.28164 14 10.2905 14 11.5C14 12.8807 12.8807 14 11.5 14C10.2905 14 9.28164 13.1411 9.05001 12H6.94999C6.71836 13.1411 5.70948 14 4.5 14C3.11929 14 2 12.8807 2 11.5C2 10.2905 2.85888 9.28164 4 9.05001L4 6.94999ZM5 9.05001L5 6.94999C5.97957 6.75115 6.75115 5.97956 6.94999 5H9.05001C9.24885 5.97956 10.0204 6.75115 11 6.94999V9.05001C10.0204 9.24885 9.24885 10.0204 9.05001 11H6.94999C6.75115 10.0204 5.97956 9.24885 5 9.05001ZM4.5 10C3.67157 10 3 10.6716 3 11.5C3 12.3284 3.67157 13 4.5 13C5.32843 13 6 12.3284 6 11.5C6 10.6716 5.32843 10 4.5 10ZM10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5C13 12.3284 12.3284 13 11.5 13C10.6716 13 10 12.3284 10 11.5ZM13 4.5C13 5.32843 12.3284 6 11.5 6C10.6716 6 10 5.32843 10 4.5C10 3.67157 10.6716 3 11.5 3C12.3284 3 13 3.67157 13 4.5Z"
      />
    </svg>
  )
})

export default Group
